import { MessageSquare } from 'lucide-react';
import { contact } from '@/content/et/contact';
import { site } from '@/content/et/site';
import { formatPhoneHref } from '@/lib/format';
import { Button } from '@/components/ui/Button';
import styles from './Hero.module.css';

export function Hero() {
  return (
    <section className={styles.hero} aria-labelledby="hero-title">
      <div className={styles.media} aria-hidden="true">
        <img
          src="/images/engine.webp"
          alt=""
          className={styles.mediaImg}
          width={1920}
          height={1072}
          fetchPriority="high"
          decoding="async"
        />
        <div className={styles.scrim} />
        <div className={styles.gridOverlay} />
      </div>

      <div className={`container ${styles.content}`}>
        <div className={styles.marks} aria-hidden="true">
          <span className={styles.mark} data-c="tl" />
          <span className={styles.mark} data-c="tr" />
        </div>

        <p className={styles.kicker}>{site.hero.kicker}</p>
        <h1 id="hero-title" className={styles.title}>
          {site.hero.title}
        </h1>
        <p className={styles.subtitle}>{site.hero.subtitle}</p>

        <div className={styles.actions}>
          <Button href="#kontakt" variant="primary">
            <MessageSquare size={20} strokeWidth={1.75} aria-hidden />
            {site.nav.contact}
          </Button>
          <a
            href={formatPhoneHref(contact.phoneE164)}
            className={styles.phoneLink}
          >
            {contact.phoneDisplay}
          </a>
        </div>

        {/* Merged trust / status strip — machine-readable meta */}
        <dl className={styles.meta}>
          <div className={styles.metaItem}>
            <dt>Asukoht</dt>
            <dd>
              {contact.city} · {contact.workshopAddressLines[0]}
            </dd>
          </div>
          <div className={styles.metaItem}>
            <dt>Fookus</dt>
            <dd>{site.trust.quality}</dd>
          </div>
          <div className={styles.metaItem}>
            <dt className={styles.metaMono}>Alates 35€</dt>
            <dd>Hind sisaldab KM</dd>
          </div>
          <div className={styles.metaItem}>
            <dt>Kontakt</dt>
            <dd>
              <a href={formatPhoneHref(contact.phoneE164)}>
                {contact.phoneDisplay}
              </a>
            </dd>
          </div>
        </dl>
      </div>
    </section>
  );
}
